// extracted by mini-css-extract-plugin
module.exports = {"ReportTile":"Reports_ReportTile__jsJkY","Separator":"Reports_Separator__1n6A1","ampSavingsIcon":"Reports_ampSavingsIcon__3LjfV","ampRevenueIcon":"Reports_ampRevenueIcon__32_Sh"};